import React from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Navbar from "../components/navbar";
import Footer from "../components/footer";

export default function ({ children }) {
  return (
    <main>
      <Navbar />
      {children}
      <Footer />
    </main>
  );
}
